import { render } from "./Principal.vue?vue&type=template&id=29696f66"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"

import "./Principal.vue?vue&type=style&index=0&id=29696f66&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__